module.exports = __webpack_public_path__ + "img/descr-fac.93c6f402.png";